import { useSelector } from "react-redux";
import { IStoreState } from "../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../hooks";
import React from "react";
import { Grid } from "@mui/material";
import { StandardCellList } from "../../../../components/Standards";
import { formatTime } from "../../../../helpers";
import { IAddGaragePlate } from "../../../../redux/TaskReducer/GaragePlate/garagePlate.types";
import { fetchAddGaragePlateAysnc } from "../../../../redux/TaskReducer/GaragePlate/garagePlateActions";
import { LoadState } from "../../../../constants/enums";
import { PageLoader } from "../../../../components/PageLoader/PageLoader";

export const ViewAddGaragePlate: React.FC<{
  taskCode: string;
}> = (props) => {
  const { taskCode } = props;

  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.tasks.garagePlate.addGaragePlate
  );

  const dispatch = useDispatchWrapper();
  const [garagePlateDetails, setGaragePlateDetails] = React.useState<IAddGaragePlate>();

  React.useEffect(() => {
    dispatch(fetchAddGaragePlateAysnc(taskCode));
  }, [taskCode]);

  React.useEffect(() => {
    setGaragePlateDetails(data);
  }, [data]);

  return (
    <PageLoader loading={loading === LoadState.InProgress}>
      {garagePlateDetails && (
        <Grid container spacing={1} sx={{ mt: 2 }}>
     
          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Garage Plate Information"
              colSize={3}
              list={[
                {
                  heading: "Plate number",
              
                  data: {
                    type: "text",
                    value: garagePlateDetails.plate_number,
                  },
                },
                {
                  heading: "Plate Type",
                  data: {
                    type: "text",
                    value: garagePlateDetails.plate_type,
                  },
                },
                {
                  heading: "Effective Date",
                  data: {
                    type: "text",
                    value: garagePlateDetails.effective_date_of_change,
                  },
                },
                {
                  heading: "Effective Time",
                  data: {
                    type: "text",
                    value: formatTime(garagePlateDetails.effective_time_of_change.toString()),
                  },
                },
                {
                  heading: "Details",
                  colSize: 12,
                  data: {
                    type: "text",
                    value: garagePlateDetails.details,
                  },
                },
              ]}
            />
          </Grid>
        </Grid>
      )}
    </PageLoader>
  );
};
